import type { EntityOptions } from 'models';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: Break circular dependency
import { CommunityCard } from 'features/communities/components/community-card';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: Break circular dependency
import { EventCard } from 'features/events/components/event-card';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: Break circular dependency
import { GivingCard } from 'features/givings/components/giving-card';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: Break circular dependency
import { GroupCard } from 'features/groups/components/group-card';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: Break circular dependency
import { OrganizationCard } from 'features/organizations/components/organization-card';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: Break circular dependency
import { ProgramCard } from 'features/programs/components/program-card';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: Break circular dependency
import { VideoCard } from 'features/videos/components/video-card';
import type { EntityListItem } from '../../types';

type P = {
  entity: EntityListItem;
  getPathToEntityDetail: (id: string, options: EntityOptions) => string;
  showPrice?: boolean;
  showTag?: boolean;
};

// TODO: move this out of channels, as some of these entities do not belong to the channels
const EntityCard = ({ entity, getPathToEntityDetail, showPrice, showTag }: P) => {
  switch (entity.type) {
    case 'Community':
      return (
        <CommunityCard
          community={entity.data}
          getPathToCommunityDetail={(id) => getPathToEntityDetail(id, { entityType: 'community' })}
          showTag={showTag}
        />
      );
    case 'Event':
      return (
        <EventCard
          event={entity.data}
          getPathToEventDetail={(id) => getPathToEntityDetail(id, { entityType: 'event' })}
          showTag={showTag}
        />
      );
    case 'Giving':
      return (
        <GivingCard
          getPathToGivingDetail={(id) => getPathToEntityDetail(id, { entityType: 'giving' })}
          giving={entity.data}
          showTag={showTag}
        />
      );
    case 'Group':
      return (
        <GroupCard
          getPathToGroupDetail={(id) => getPathToEntityDetail(id, { entityType: 'group' })}
          group={entity.data}
          showTag={showTag}
        />
      );
    case 'Organization':
      return (
        <OrganizationCard
          getPathToOrganizationDetail={(id) => getPathToEntityDetail(id, { entityType: 'organization' })}
          organization={entity.data}
          showTag={showTag}
        />
      );
    case 'Program':
      return (
        <ProgramCard
          getPathToProgramDetail={(id) => getPathToEntityDetail(id, { entityType: 'program' })}
          program={entity.data}
          showPrice={showPrice}
          showTag={showTag}
        />
      );
    case 'Video':
      return (
        <VideoCard
          getPathToVideoDetail={(id) => getPathToEntityDetail(id, { entityType: 'video' })}
          showTag={showTag}
          video={entity.data}
        />
      );
  }
};

export default EntityCard;
